module.exports = __webpack_public_path__ + "img/5.3c73f599.jpg";